export default __webpack_public_path__ + "clientapp/media/robot-09.c3b45372.png";